import { render, staticRenderFns } from "./AssignSpareTab.vue?vue&type=template&id=2879a3ac"
import script from "./AssignSpareTab.js?vue&type=script&lang=js&external"
export * from "./AssignSpareTab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports